export const SET_ACTIVE_PAGE = 'SET_ACTIVE_PAGE' as const;

export interface NavigationState {
  readonly currentPage: string;
}

